<template>
<div>
  <el-main>
  <div class="look-box">
    <div class="nav-look">
      <p class="nav-title">信用调查报告</p>
      <p class="nav-time">
        <span>报告生成时间：</span>
        <span>{{ creditValue.reportTime }}</span>
      </p>
    </div>
    <div class="xy-grade">
      <p class="circular-left"></p>
      <p class="circular-right"></p>
      <div class="header">
        <p>
          信用评级：
          <span>
            <svg-icon iconClass="danger" v-if="creditValue.rating == 3"></svg-icon>
            <svg-icon v-else iconClass="security"></svg-icon>
          </span>
          <span :style="creditValue.rating == 2 ? 'color:#3AC697' : 'color:#FF6752'">
            {{ creditValue.rating == 2 ? "安全" : "存在风险" }}
          </span>
        </p>
      </div>
      <div class="infor">
        <p>
          <span>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</span><span>{{ creditValue.personName }}</span>
        </p>
        <p>
          <span>手&nbsp;&nbsp;机&nbsp;&nbsp;号：</span><span>{{ creditValue.personMobile }}</span>
        </p>
        <p v-if="creditValue.personIdCard !== '' && creditValue.personIdCard !== null">
          <span>身份证号：</span><span>{{ creditValue.personIdCard }}</span>
        </p>
        <p v-if="creditValue.personBankCard !== '' && creditValue.personBankCard !== null">
          <span>银行卡号：</span><span>{{ creditValue.personBankCard }}</span>
        </p>
      </div>
    </div>
    <div class="infor-look" v-if="creditInfo && creditInfo !== null && creditInfo.personName ">
      <span></span>不良信息核查
    </div>
    <table id="customers" v-if="creditInfo  && creditInfo !== null && creditInfo.personName ">
      <tr>
        <th>姓名</th>
        <td>{{ creditInfo.personName }}</td>
        <th>身份证</th>
        <td>{{ creditInfo.personIdCard }}</td>
      </tr>
      <tr>
        <th>核验结果</th>
        <td>
          <span>
            <svg-icon iconClass="security" v-if="creditInfo.result == 'Z'"></svg-icon>
            <svg-icon v-else iconClass="danger"></svg-icon>
          </span>
          <span :style="creditInfo.result == 'Z' ? 'color:#3AC697' : 'color:#FF6752'">
            {{
              creditInfo.result == "A"
                ? "在逃"
                : creditInfo.result == "B"
                ? "前科"
                : creditInfo.result == "C"
                ? "吸毒"
                : creditInfo.result == "D"
                ? "涉毒"
                : creditInfo.result == "E"
                ? "涉案人员"
                : creditInfo.result == "F"
                ? "犯罪嫌疑人"
                : creditInfo.result == "Z"
                ? "正常"
                : creditInfo.result
            }}
          </span>
        </td>
        <th></th>
        <td></td>
      </tr>
    </table>
    <div class="infor-look" v-if="creditFraud && creditFraud !== null && creditFraud.mobile">
      <span></span>羊毛反欺诈查询
    </div>
    <table id="customers" v-if="creditFraud && creditFraud !== null && creditFraud.mobile">
      <tr>
        <th>手机号</th>
        <td>{{ creditFraud.mobile }}</td>
        <th>核验结果</th>
        <td>
          <span>
            <svg-icon iconClass="security" v-if="creditFraud.status == 'W1' || creditFraud.status == 'N'"></svg-icon>
            <svg-icon v-else iconClass="danger"></svg-icon>
          </span>
          <span :style="creditFraud.status == 'W1' || creditFraud.status == 'N' ? 'color:#3AC697' : 'color:#FF6752'">
            {{
              creditFraud.status == "W1"
                ? "白名单"
                : creditFraud.status == "B1"
                ? "黑名单"
                : creditFraud.status == "B2"
                ? "可信用度低"
                : creditFraud.status == "N"
                ? "未查询到数据"
                : creditFraud.status
            }}
          </span>
        </td>
      </tr>
    </table>
    <div class="infor-look" v-if="creditBlack && creditBlack !== null && creditBlack.personIdCard">
      <span></span>金融黑名单查询（身份证）
    </div>
    <table id="customers" v-if="creditBlack && creditBlack !== null && creditBlack.personIdCard">
      <tr>
        <th>身份证</th>
        <td>{{ creditBlack.personIdCard }}</td>
        <th>核验结果</th>
        <td>
          <span>
            <svg-icon iconClass="security" v-if="creditBlack.result == 0"></svg-icon>
            <svg-icon v-else iconClass="danger"></svg-icon>
          </span>
          <span :style="creditBlack.result == 0 ? 'color:#3AC697' : 'color:#FF6752'">
            {{ creditBlack.result == 0 ? "未命中" : creditBlack.result == 1 ? "命中" : creditBlack.result }}
          </span>
        </td>
      </tr>
      <tr>
        <th>是否命中不良持卡人</th>
        <td>{{ creditBlack.badCardholder == 0 ? "未命中" : creditBlack.badCardholder == 1 ? "命中" : ''}}</td>
        <th>是否命中经济犯罪人员</th>
        <td>{{ creditBlack.economicCrime == 0 ? "未命中" : creditBlack.economicCrime == 1 ? "命中" : '' }}</td>
      </tr>
      <tr>
        <th>是否命中失信人员</th>
        <td>{{ creditBlack.dishonestPerson == 0 ? "未命中" : creditBlack.dishonestPerson == 1 ? "命中" : '' }}</td>
        <th>是否命中涉恐人员</th>
        <td>{{ creditBlack.terrorist == 0 ? "未命中" : creditBlack.terrorist == 1 ? "命中" : '' }}</td>
      </tr>
      <tr>
        <th>是否命中触犯风险规则人员</th>
        <td>{{ creditBlack.riskPerson == 0 ? "未命中" : creditBlack.riskPerson == 1 ? "命中" : '' }}</td>
        <th></th>
        <td></td>
      </tr>
    </table>
    <div class="infor-look" v-if="creditBank && creditBank !== null && creditBank.personBankCard">
      <span></span>金融黑名单查询（银行卡）
    </div>
    <table id="customers" v-if="creditBank && creditBank !== null && creditBank.personBankCard">
      <tr>
        <th>银行卡号</th>
        <td>{{ creditBank.personBankCard }}</td>
        <th>核验结果</th>
        <td>
          <span>
            <svg-icon iconClass="security" v-if="creditBank.result == 0"></svg-icon>
            <svg-icon v-else iconClass="danger"></svg-icon>
          </span>
          <span :style="creditBank.result == 0 ? 'color:#3AC697' : 'color:#FF6752'">
            {{ creditBank.result == 0 ? "未命中" : creditBank.result == 1 ? "命中" : creditBank.result }}
          </span>
        </td>
      </tr>
      <tr>
        <th>是否命中不良持卡人</th>
        <td>{{ creditBank.badCardholder == 0 ? "未命中" : creditBank.badCardholder == 1 ? "命中" : '' }}</td>
        <th>是否命中欺诈交易卡片</th>
        <td>{{ creditBank.fraudulentTrans == 0 ? "未命中" : creditBank.fraudulentTrans == 1 ? "命中" : '' }}</td>
      </tr>
      <tr>
        <th>是否命中涉案卡片</th>
        <td>{{ creditBank.involved == 0 ? "未命中" : creditBank.involved == 1 ? "命中" : '' }}</td>
        <th>是否命中线下卡号黑名单</th>
        <td>{{ creditBank.offlineBlacklist == 0 ? "未命中" : creditBank.offlineBlacklist == 1 ? "命中" : '' }}</td>
      </tr>
      <tr>
        <th>是否命中线上卡号黑名单</th>
        <td>{{ creditBank.onlineBlacklist == 0 ? "未命中" : creditBank.onlineBlacklist == 1 ? "命中" : '' }}</td>
        <th>是否命中其它卡号黑名单</th>
        <td>{{ creditBank.otherBlacklist == 0 ? "未命中" : creditBank.otherBlacklist == 1 ? "命中" : '' }}</td>
      </tr>
    </table>
    <div class="infor-look" v-if="creditTel && creditTel !== null && creditTel.personMobile">
      <span></span>金融黑名单查询（手机号）
    </div>
    <table id="customers" v-if="creditTel && creditTel !== null && creditTel.personMobile">
      <tr>
        <th>手机号</th>
        <td>{{ creditTel.personMobile }}</td>
        <th>核验结果</th>
        <td>
          <span>
            <svg-icon iconClass="security" v-if="creditTel.result == 0"></svg-icon>
            <svg-icon v-else iconClass="danger"></svg-icon>
          </span>
          <span :style="creditTel.result == 0 ? 'color:#3AC697' : 'color:#FF6752'">
            {{ creditTel.result == 0 ? "未命中" : creditTel.result == 1 ? "命中" : creditTel.result }}
            </span>
        </td>
      </tr>
      <tr>
        <th>是否命中银联线上的交易手机号黑名单</th>
        <td>{{ creditTel.unionpayBlacklist == 0 ? "未命中" : creditTel.unionpayBlacklist == 1 ? "命中" : '' }}</td>
        <th>是否命中期诈交易卡片</th>
        <td>{{ creditTel.fraudMobile == 0 ? "未命中" : creditTel.fraudMobile == 1 ? "命中" : '' }}</td>
      </tr>
      <tr>
        <th>是否命中欺诈电话号码</th>
        <td>{{ creditTel.fakeMobile == 0 ? "未命中" : creditTel.fakeMobile == 1 ? "命中" : '' }}</td>
        <th></th>
        <td></td>
      </tr>
    </table>
  </div>
  </el-main>
</div>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      creditValue: {},
      creditBlack: {},
      creditBank: {},
      creditTel: {},
      creditFraud: {},
      creditInfo: {},
    };
  },
  created() {
   
    this.id = this.$route.query.id;
    this.$axios.get("/bi/getResultData?biId="+this.id).then((res) => {
    
     
      this.creditValue = res.data.data;

      // this.creditBlack = res.data.data.creditFinancialBlacklistIdCardDTO;
      // this.creditBank = res.data.data.creditFinancialBlacklistBankDTO;
      // this.creditTel = res.data.data.creditFinancialBlacklistTelDTO;
      // this.creditFraud = res.data.data.creditAntiFraudDTO;

      if(res.data.data.creditBadInfoDTO){
      this.creditInfo = res.data.data.creditBadInfoDTO;

      }else {
      this.creditInfo = {};
       
      }
        if(res.data.data.creditFinancialBlacklistIdCardDTO){
        this.creditBlack = res.data.data.creditFinancialBlacklistIdCardDTO;

      }else {
      this.creditBlack = {};
       
      }
        if(res.data.data.creditFinancialBlacklistBankDTO){
      this.creditBank = res.data.data.creditFinancialBlacklistBankDTO;

      }else {
      this.creditBank = {};
       
      }
           if(res.data.data.creditFinancialBlacklistTelDTO){
      this.creditTel = res.data.data.creditFinancialBlacklistTelDTO;

      }else {
      this.creditTel = {};
       
      }
             if(res.data.data.creditAntiFraudDTO){
      this.creditFraud = res.data.data.creditAntiFraudDTO;

      }else {
      this.creditFraud = {};
       
      }

    });
  
  },
};
</script>

<style lang="less" scoped>
.el-main {
  height: calc(100vh - 60px);
}
p {
  padding: 0;
  margin: 0;
}
.look-box {
  padding: 32px 50px;
  .nav-look {
    .nav-title {
      font-size: 24px;
      font-weight: bold;
      color: #303140;
      margin-bottom: 14px;
    }
    .nav-time {
      span {
        font-size: 12px;
        font-weight: 400;
        color: #303140;
      }
    }
  }
  .xy-grade {
    width: 100%;
    // height: 180px;
    background: #f2f3f8;
    border-radius: 4px;
    margin-top: 32px;
    position: relative;
    padding-bottom: 15px;
    .header {
      font-size: 18px;
      font-weight: bold;
      color: #303140;
      padding: 13px 15px;
      border-bottom: 1px dashed #d5d5de;
      background: #e9ecf2;
      .svg-icon {
        width: 16px;
        height: 16px;
        display: inline-block;
      }
    }
    .circular-left {
      position: absolute;
      width: 16px;
      height: 16px;
      background: #ffffff;
      top: 45px;
      border-radius: 50%;
      left: -9px;
    }
    .circular-right {
      position: absolute;
      width: 16px;
      height: 16px;
      background: #ffffff;
      right: -9px;
      top: 45px;
      border-radius: 50%;
    }
    .infor {
      p {
        font-size: 12px;
        font-weight: 400;
        color: #545566;
        margin-left: 15px;
        margin-top: 10px;
      }
    }
  }
  .infor-look {
    font-size: 14px;
    font-weight: bold;
    color: #303140;
    margin-top: 23px;
    span {
      display: inline-block;
      width: 4px;
      height: 12px;
      background: #6669e3;
      border-radius: 4px;
      margin-right: 7px;
    }
  }
}
#customers {
  font-size: 12px;
  font-weight: 400;
  color: #303140;
  width: 100%;
  margin-top: 10px;
  td,
  th {
    border: 1px solid #e9e9ef;
    padding: 3px 7px 2px 7px;
  }
  th {
    color: #545566;
    height: 40px;
    width: 134px;
    box-sizing: border-box;
    text-align: center;
    padding-top: 5px;
    padding-bottom: 4px;
    background: #f5f6fa;
  }
  td {
    width: 400px;
  }
}
</style>